import { render, staticRenderFns } from "./coming-soon.vue?vue&type=template&id=ee672e0a&"
import script from "./coming-soon.vue?vue&type=script&lang=js&"
export * from "./coming-soon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./coming-soon-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fviews%2Futilities%2Fcoming-soon.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports